import './src/ui/global.css'

import React from 'react'
import type { GatsbyBrowser } from 'gatsby'

import { App } from './src/app'
import { SiteLayout } from './src/layouts/site-layout'

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  return React.createElement(
    App,
    {},
    React.createElement(SiteLayout, { location: props.location }, element)
  )
}

